import React from 'react';
import classNames from 'classnames';
import { formatNumber } from '../../../common/utils';
import { formatLabel } from '../../utils';
var ThermometerLegend = function (_a) {
    var valueLabelPairs = _a.valueLabelPairs, dataType = _a.dataType;
    return (React.createElement("div", { className: 'thermometerLegend__container' }, valueLabelPairs.map(function (pair, index) { return (React.createElement("div", { key: "pair-" + index, className: 'thermometerLegend__dataPoint' },
        React.createElement("div", { className: classNames('thermometerLegend__dot', "thermometerLegend__dot--" + pair.severity) }),
        React.createElement("div", { className: "thermometerLegend__label" }, formatLabel(pair.label, dataType)),
        React.createElement("div", { className: "thermometerLegend__value" },
            "(",
            formatNumber(pair.value),
            ")"))); })));
};
export default ThermometerLegend;
//# sourceMappingURL=ThermometerLegend.js.map